import { Link } from 'react-router-dom';
import { ShieldAlert, ArrowLeft, Users, UserCog } from 'lucide-react';

const roleLabels = {
  admin: 'Administrador',
  operador: 'Operador',
  financeiro: 'Financeiro',
};

export default function AccessDenied({ allowedRoles = [], pageName = 'esta página' }) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6" data-testid="access-denied-page">
      <div className="max-w-md w-full text-center space-y-6">

        {/* Icon */}
        <div className="flex justify-center">
          <div className="relative">
            <div className="w-24 h-24 rounded-full flex items-center justify-center"
              style={{ background: 'linear-gradient(135deg, #EEF2FF, #c7d2fe)' }}>
              <ShieldAlert className="w-11 h-11" style={{ color: '#0147a0' }} />
            </div>
            {/* Decorative ring */}
            <div className="absolute inset-0 rounded-full border-2 border-dashed animate-spin"
              style={{ borderColor: 'rgba(1,71,160,0.15)', animationDuration: '8s' }} />
          </div>
        </div>

        {/* Text */}
        <div>
          <h1 className="text-2xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Acesso Restrito
          </h1>
          <p className="text-slate-500 text-sm leading-relaxed">
            Você não tem permissão para acessar <strong className="text-slate-700">{pageName}</strong>.
            <br />
            Esta área é exclusiva para os seguintes perfis:
          </p>
        </div>

        {/* Allowed roles */}
        <div className="flex flex-wrap justify-center gap-2">
          {allowedRoles.map((role) => (
            <div key={role}
              className="flex items-center gap-2 px-4 py-2 rounded-xl border font-semibold text-sm"
              style={{ background: '#EEF2FF', borderColor: '#c7d2fe', color: '#0147a0' }}>
              {role === 'admin' ? <UserCog className="w-4 h-4" /> : <Users className="w-4 h-4" />}
              {roleLabels[role] || role}
            </div>
          ))}
        </div>

        {/* Info card */}
        <div className="rounded-2xl border p-4 text-left text-sm"
          style={{ background: '#fffbeb', borderColor: '#fde68a' }}>
          <p className="font-semibold text-amber-800 mb-1">Precisa de acesso?</p>
          <p className="text-amber-700 text-xs leading-relaxed">
            Solicite ao administrador do sistema que ajuste seu perfil de acesso. Seu perfil atual não possui as permissões necessárias para esta funcionalidade.
          </p>
        </div>

        {/* Back button */}
        <Link
          to="/dashboard"
          data-testid="btn-voltar-dashboard"
          className="inline-flex items-center gap-2 text-white font-bold px-6 py-3 rounded-xl transition-all hover:shadow-lg hover:-translate-y-0.5"
          style={{ background: 'linear-gradient(135deg, #0147a0, #003375)' }}
        >
          <ArrowLeft className="w-4 h-4" />
          Voltar ao Dashboard
        </Link>
      </div>
    </div>
  );
}
